import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Intent, Alert, Icon, Spinner } from "@blueprintjs/core";
import { observable } from 'mobx';
import Toast from 'helpers/toaster';

const initials = (name = '') =>
  String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');

const addressOf = (customer) => {
  const a = customer.shipping_address;
  return a ? [a.line1, a.city, a.postal_code].filter(Boolean).join(', ') : '';
};

// One QuickBooks customer in the "Link to QuickBooks" panel: who it is, and a
// Link button (confirmed first).
@inject('invoiceStore', 'quickbooksStore') @observer
class QuickbooksCustomer extends Component {

  @observable showLoader = false;
  @observable isLinkCustomerWithQuickbooks = false;

  linkCustomer() {
    this.isLinkCustomerWithQuickbooks = true
  }

  handleCustomerLinkCancel() {
    this.isLinkCustomerWithQuickbooks = false
  }

  handleSaveConfirm() {
    this.isLinkCustomerWithQuickbooks = false
    this.showLoader = true;
    this.props.quickbooksStore.linkClientWithQuickbooksCustomer(this.props.customer)
      .then(() => {
        this.showLoader = false;
        this.props.onSuccess();
        Toast.show({ message: "Client linked to QuickBooks.", intent: Intent.SUCCESS })
      })
      .catch(() => {
        this.showLoader = false;
        Toast.show({ message: "Couldn’t link the client. Reconnect QuickBooks in Settings and try again.", intent: Intent.DANGER })
      })
  }

  render() {
    const { customer, clientName } = this.props;
    const company = customer.display_name || 'Unnamed customer';
    const person = [customer.given_name, customer.family_name].filter(Boolean).join(' ');
    const address = addressOf(customer);
    return (
      <li className="qb-customer">
        <span className="qb-customer__avatar" aria-hidden="true">{initials(company)}</span>
        <span className="qb-customer__text">
          <span className="qb-customer__name">{company}</span>
          {(person || address) && (
            <span className="qb-customer__meta">
              {person && <span>{person}</span>}
              {address && <span><Icon icon="map-marker" iconSize={11} />{address}</span>}
            </span>
          )}
        </span>
        <button
          type="button"
          className="fb-inline-action"
          onClick={this.linkCustomer.bind(this)}
          disabled={this.showLoader}
          aria-label={`Link to ${company}`}
        >
          {this.showLoader ? <Spinner size={12} /> : <Icon icon="link" iconSize={12} />}
          Link
        </button>
        <Alert
          cancelButtonText="Cancel"
          confirmButtonText="Link customer"
          icon="link"
          intent={Intent.PRIMARY}
          isOpen={this.isLinkCustomerWithQuickbooks}
          onCancel={this.handleCustomerLinkCancel.bind(this)}
          onConfirm={this.handleSaveConfirm.bind(this)}
        >
          <strong>Link {clientName || 'this client'} to {company}?</strong>
          <p>This client’s invoices will sync to that QuickBooks customer.</p>
          {address && <p>{address}</p>}
        </Alert>
      </li>
    )
  }

}

export default QuickbooksCustomer;
